import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  TUIStore,
  StoreName,
  IConversationModel,
  TUITranslateService
} from '../../../../@aidesk/uikit-engine';
import vue from '../../../../adapter-vue';
import faceIcon from '../../../../assets/face.svg';
import EmojiPickerDialog from './emoji-picker-dialog.vue';
import ToolbarItemContainer from '../toolbar-item-container/index.vue';
import { isH5 } from '../../../../utils/env';
import { ToolbarDisplayType } from '../../../../interface';
interface IProps {
  isH5EmojiShow:boolean;
}

interface IEmits {
  (e: 'sendMessage'): void;
  (e: 'toggleComponent'): void;
  (e: 'insertEmoji', emoji: any): void;
  (e: 'dialogShowInH5', dialogRef: HTMLElement): void;
  (e: 'dialogCloseInH5', dialogRef: HTMLElement): void;
  (e: 'changeToolbarDisplayType', type: ToolbarDisplayType): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    isH5EmojiShow: { type: Boolean, default: false }
  },
  emits: ["sendMessage", "toggleComponent", "insertEmoji", "dialogShowInH5", "dialogCloseInH5", "changeToolbarDisplayType"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const { ref } = vue;

const emits = __emit;
const currentConversation = ref();
const container = ref<InstanceType<typeof ToolbarItemContainer>>();

const props = __props;


TUIStore.watch(StoreName.CONV, {
  currentConversation: (conversation: IConversationModel) => {
    currentConversation.value = conversation;
  },
});

const onDialogShow = (dialogRef: any) => {
  if (!isH5) {
    return;
  }
  emits('changeToolbarDisplayType', 'emojiPicker');
  emits('dialogShowInH5', dialogRef.value);
};

const onDialogClose = (dialogRef: any) => {
  if (!isH5) {
    return;
  }
  emits('changeToolbarDisplayType', 'none');
  emits('dialogCloseInH5', dialogRef.value);
};

const insertEmoji = (emojiObj) => {
  emits('insertEmoji', emojiObj);
};
const sendMessage = () => {
  emits('sendMessage');
};
const onClose = () => {
  container.value?.toggleDialogDisplay(false);
};

__expose({
  closeEmojiPicker: onClose,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ToolbarItemContainer, {
    ref_key: "container",
    ref: container,
    iconFile: _unref(faceIcon),
    title: _unref(TUITranslateService).t('表情'),
    onOnDialogShow: onDialogShow,
    onOnDialogClose: onDialogClose,
    isH5EmojiShow: props.isH5EmojiShow,
    isH5Emoji: _unref(isH5)
  }, {
    default: _withCtx(() => [
      _createVNode(EmojiPickerDialog, {
        onInsertEmoji: insertEmoji,
        onSendMessage: sendMessage,
        onOnClose: onClose
      })
    ]),
    _: 1
  }, 8, ["iconFile", "title", "isH5EmojiShow", "isH5Emoji"]))
}
}

})